/**
 * Formats a video clip length (`AdminReportMediaDto.durationSec`) as
 * `m:ss` — `0:32`, `2:07`, `12:05` (AUT-272 walkaround clips).
 *
 * Digits + a colon only, so it carries no localisable words and needs
 * no i18n key (CLAUDE.md rule #11 covers *words*, not numerals).
 *
 * Returns `null` for anything that can't be rendered honestly — a null
 * duration (the media pipeline hasn't probed the file yet), a negative
 * value, or a non-finite one. Callers omit the badge in that case
 * rather than printing a made-up `0:00`.
 */
export const formatClipDuration = (durationSec: number | null): string | null => {
  if (durationSec === null || !Number.isFinite(durationSec) || durationSec < 0) return null;

  const total = Math.round(durationSec);
  const minutes = Math.floor(total / 60);
  const seconds = total % 60;

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};
